<template>
    <div>
      <v-row class="text-xs-left" :class="{'fixedPlayer': scrolltop > 100 }">
        <v-col xs12 md6 offset-md3>
          <v-row>
            <v-col xs10 offset-xs2>
              <v-alert error dismissible v-model="alert">
                請選擇音檔！
              </v-alert>
            </v-col>

            <v-col xs2 class="text-xs-right">
              <br />
              <span v-on:click="toggleAudio()" v-if="audio.autoplay === 'enable'">
                <img src="~../assets/images/btn_play.svg" v-if="audio.state === 'pause'" />
                <img src="~../assets/images/btn_pause.svg" v-if="audio.state === 'play'" />
              </span>
            </v-col>

            <v-col xs10 class="text-xs-left">
              目前播放音檔：{{ audio.title }} <br />
              <template v-if="audio.autoplay === 'enable'">
                <audio ref="audio" :src="audio.url"></audio>
                <v-progress-linear :value="audio.currentPos" height="20" fill="#6c729d"></v-progress-linear>
              </template>
              <template v-else>
                <audio ref="audio" :src="audio.url" :controls="true" style="display: block; width: 100%;"></audio>
              </template>
            </v-col>
          </v-row>

          <v-row v-if="audio.autoplay === 'enable'">
            <v-col xs12 class="text-xs-right">
              {{ duration(audio.currentTime) }} / {{ duration(audio.duration) }}
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <hr />

      <v-row class="text-xs-left"
        v-for="(area, key, index) in areas" :key="index">
        <v-col sm10 offset-sm2 md5 offset-md4>
          <div class="big-title" v-bind:class="{ 'color-1': (index + 1) === 1, 'color-2': (index + 1) === 2, 'color-3': (index + 1) === 3 }">
            {{ key }}
            <span v-on:click="toggle(index + 1)">
              <img src="~../assets/images/btn_down_arrow.svg" v-if="!section['s' + (index + 1)]">
              <img src="~../assets/images/btn_up_arrow.svg" v-if="section['s' + (index + 1)]">
            </span>
          </div>
        </v-col>

        <v-col sm10 offset-sm2 md5 offset-md4 v-if="section['s' + (index + 1)]">
          <div v-for="(section, section_key, section_index) in area">
            <div class="title" v-bind:class="{ 'color-1': (index + 1) === 1, 'color-2': (index + 1) === 2, 'color-3': (index + 1) === 3 }">{{ section_key }}</div>

            <div class="content" v-bind:class="{ 'color-1': (index + 1) === 1, 'color-2': (index + 1) === 2, 'color-3': (index + 1) === 3 }" v-for="(place, place_key, place_index) in section">
               {{ place_key }}
              <div class="track" v-bind:class="{ 'track-color-1': (index + 1) === 1, 'track-color-2': (index + 1) === 2, 'track-color-3': (index + 1) === 3 }">
                <div v-for="(track, track_key) in place"> {{ track_key }} {{ track }}
                  <span v-on:click="selectTrack(track, track_key)"><img src="~../assets/images/btn_play_small.svg"></span>
                  <span><a :href="'/taichung/static/mp3/' + track + '.mp3'" download><img src="~../assets/images/btn_download.svg"></a></span>
                </div>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </div>
</template>

<script>
import moment from 'moment'
import 'moment-duration-format'

export default {

  name: 'BookAudio',

  data () {
    return {
      section: {
        s1: false,
        s2: false,
        s3: false
      },

      serialno: 0,

      areas: {
        '臺中市中心區': {
          '北區': {
            '1. 國立自然科學博物館': {
              '科博館簡介': 'Track 01',
              '科博館旅遊': 'Track 02'
            },
            '2. 植物園': {
              '植物園簡介': 'Track 03',
              '帶外國朋友認識臺灣植物': 'Track 04'
            },
            '3. 臺中公園': {
              '臺中公園簡介': 'Track 05',
              '帶外國朋友遊臺中公園': 'Track 06'
            }
          },
          '中區': {
            '4. 臺中州廳': {
              '臺中州廳簡介': 'Track 07',
              '帶外國朋友遊臺中州廳': 'Track 08'
            }
          },
          '西區': {
            '5. 范特喜與綠光計劃': {
              '范特喜與綠光計劃簡介': 'Track 09',
              '帶外國朋友遊綠光計劃': 'Track 10'
            },
            '6. 國立臺灣美術館': {
              '國立臺灣美術館簡介': 'Track 11',
              '逛逛國立臺灣美術館': 'Track 12'
            },
            '7. 臺中文學館': {
              '臺中文學館簡介': 'Track 13',
              '參觀臺中文學館': 'Track 14'
            },
            '8. 勤美術館': {
              '勤美術館簡介': 'Track 15',
              '來去勤美術館': 'Track 16'
            }
          },
          '南區': {
            '9. 臺中文化創意產業園區': {
              '臺中文化創意產業園區': 'Track 17',
              '悠遊臺中文化創業產業園區': 'Track 18'
            }
          }
        },
        '臺中市屯區': {
          '南屯區': {
            '10. 彩虹眷村': {
              '彩虹眷村簡介': 'Track 19',
              '帶外國朋友遊彩虹眷村': 'Track 20'
            }
          },
          '北屯區': {
            '11. 臺中民俗文物館': {
              '臺中民俗文物館': 'Track 21',
              '參觀臺中民俗文物館': 'Track 22'
            }
          },
          '西屯區': {
            '12. 逢甲夜市': {
              '逢甲夜市簡介': 'Track 23',
              '帶外國朋友玩逢甲夜市': 'Track 24'
            },
            '13. 秋紅谷廣場': {
              '秋紅谷廣場簡介': 'Track 25',
              '帶外國朋友遊秋紅谷廣場': 'Track 26'
            },
            '14. 臺中國家歌劇院': {
              '臺中國家歌劇院簡介': 'Track 27',
              '參觀臺中國家歌劇院': 'Track 28'
            },
            '15. 東海大學': {
              '東海大學簡介': 'Track 29',
              '帶外國朋友遊路思義教堂': 'Track 30'
            }
          }
        },
        '臺中市山、海線': {
          '后里區': {
            '16. 后豐鐵馬道': {
              '后豐鐵馬道': 'Track 31',
              '帶外國朋友遊后豐鐵馬道': 'Track 32'
            },
            '17. 麗寶樂園 - 探索樂園': {
              '麗寶樂園 - 探索樂園簡介': 'Track 33',
              '刺激有趣的探險樂園': 'Track 34'

            },
            '18. 麗寶樂園 - 馬拉灣': {
              '麗寶樂園 - 馬拉灣簡介': 'Track 35',
              '馬拉灣夏日戲水': 'Track 36'
            }
          },
          '清水區': {
            '19. 高美濕地': {
              '高美濕地簡介': 'Track 37',
              '欣賞高美濕地之美': 'Track 38'
            },
            '20. 臺中市港區藝術中心': {
              '臺中市港區藝術中心簡介': 'Track 39',
              '來去港區藝術中心': 'Track 40'
            }
          },
          '梧棲區': {
            '21. 梧棲觀光漁港': {
              '梧棲觀光漁港簡介': 'Track 41',
              '帶外國朋友遊梧棲觀光漁港': 'Track 42'
            }
          }
        }
      },

      audio: {
        el: null,
        title: '',
        url: '',
        state: 'pause',
        currentPos: 0,
        currentTime: 0,
        duration: 0,
        autoplay: 'enable'
      },

      alert: false,

      scrolltop: 0
    }
  },

  mounted () {
    var self = this

    this.audio.el = this.$refs.audio
    this.audio.el.addEventListener('timeupdate', function () {
      self.audio.currentPos = (this.currentTime / this.duration) * 100
      self.audio.duration = this.duration
      self.audio.currentTime = this.currentTime
    })

    this.audio.el.addEventListener('canplaythrough', function () {
      self.audio.el.play()
      self.audio.state = 'play'
      self.alert = false
    }, false)

    this.$watch('audio.state', () => {
      if (this.audio.state === 'play' &&
          this.audio.url.length <= 0) {
        this.alert = true
        this.audio.state = 'pause'
        return
      }

      if (this.audio.state === 'play') {
        let promise = this.audio.el.play()
        let self = this

        if (promise !== undefined) {
          promise.catch(error => {
            // Auto-play was prevented
            console.log(error)
            self.audio.autoplay = 'disable'
          }).then(() => {
            // Auto-play started
          })
        }
      } else {
        this.audio.el.pause()
      }
      console.log(this.audio.autoplay)
      // this.audio.state === 'play' ? this.audio.el.play() : this.audio.el.pause()
    })

    window.addEventListener('keyup', this.handleKeyup)
    window.addEventListener('scroll', this.handleScroll)
  },

  beforeDestroy () {
    window.removeEventListener('keyup', this.handleKeyup)
    window.removeEventListener('scroll', this.handleScroll)
  },

  methods: {
    duration: function (seconds) {
      return moment.duration(seconds, 'minutes').format('hh:mm', { trim: false })
    },

    toggle (section) {
      var self = this
      Object.keys(this.section).map(function (key, index) {
        self.section[key] = section === (index + 1) && self.section[key] === false
      })
    },

    toggleAudio () {
      this.alert = false
      this.audio.state = (this.audio.state === 'pause') ? 'play' : 'pause'

      if (this.audio.autoplay === 'disable') {
        this.audio.state === 'play' ? this.audio.el.play() : this.audio.el.pause()
      }
    },

    selectTrack (file, title) {
      this.audio.state = 'pause'
      this.audio.url = '/taichung/static/mp3/' + file + '.mp3'
      this.audio.title = title + ' ' + file
      // this.$nextTick(() => {
      this.toggleAudio()
      // })
    },

    handleKeyup (evt) {
      if (evt.keyCode === 32) {
        evt.preventDefault()
        this.toggleAudio()
      }
    },

    handleScroll () {
      let scrollNode = document.scrollingElement || document.documentElement
      this.scrolltop = scrollNode.scrollTop
    }
  }
}
</script>

<style lang="scss" scoped>
  .color-1 {
    color: #6c729d;
  }

  .color-2 {
    color: #be9a11;
  }

  .color-3 {
    color: #e84660;
  }

  .big-title {
    font-size: 2em;
    font-weight: bold;
    line-height: 300%;
  }

  span {
    cursor: pointer;

    img {
      vertical-align: middle;
    }
  }

  .title {
    font-size: 1.8em;
    line-height: 200%;
    font-weight: bold;
  }

  .content {
    font-size: 1.5em;
    line-height: 150%;

    .track {
      margin: 1em 0 1em 1em;
      color: #4d4d4d;
      padding-left: 1.5em;
    }

    .track-color-1 {
      border-left: solid 5px #6c729d;
    }

    .track-color-2 {
      border-left: solid 5px #be9a11;
    }

    .track-color-3 {
      border-left: solid 5px #e84660;
    }
  }

  .fixedPlayer {
    position: fixed;
    top:0;
    left: 0;
    padding: 0;
    margin:0;
    z-index: 5001;
    width: 100%;
    background-color: #eae9f0;
  }
</style>



// WEBPACK FOOTER //
// BookAudio.vue?75bb8340